/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface HealthResponseDto {
  /**
   * Liveness marker
   * @example "ok"
   */
  status: string;
  /**
   * The commit this process was deployed from. `unknown` on any run with no deploy behind it.
   * @example "a1b2c3d4e5f67890a1b2c3d4e5f67890a1b2c3d4"
   */
  commit: string;
}

export interface EmailChangeStartDto {
  /** Set when the caller is the mobile app. */
  mobile?: boolean;
  /** Deep link to return to. Dropped unless it is a whitegi: URI. */
  redirectUri?: string;
}

export interface EmailChangeStartResponseDto {
  /** Signed OAuth state to hand to GET /api/auth/google?state=… or /api/auth/apple?state=… */
  state: string;
  /** Seconds the state remains valid. */
  expiresInSeconds: number;
}

export interface EmailChangeCompleteDto {
  /** The assertion returned in the callback fragment */
  token: string;
}

export interface EmailChangeResultDto {
  emailChange:
    | "applied"
    | "unchanged"
    | "conflict"
    | "identity_in_use"
    | "no_email"
    | "account_missing";
}

export interface MeResponseDto {
  /** @format uuid */
  id: string;
  username: string;
  firstName: string | null;
  lastName: string | null;
  /** @format email */
  email: string;
  belt: "WHITE" | "BLUE" | "PURPLE" | "BROWN" | "BLACK" | null;
  rank: "0" | "1" | "2" | "3" | "4" | null;
  gender: "MALE" | "FEMALE" | null;
  /** Derived from onboarded_at. A boolean, not the timestamp — the client needs one bit to pick a screen, and the raw value means "when the rules changed for you", which invites date arithmetic that means nothing. */
  onboardingComplete: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface EmbedTokenResponseDto {
  /** Short-lived access token for the series-graph WebView embed. */
  accessToken: string;
  /** Hard-coded token type string so clients can validate expectations. */
  tokenType: "access";
  /** Number of seconds until the embed token expires. */
  expiresInSeconds: number;
}

export interface DevLoginDto {
  /** @example "maestro.user@white-gi.local" */
  email: string;
}

export interface AuthResponseUserDto {
  /** Unique identifier for the authenticated user. */
  id: string;
  /** Username pulled from the OAuth provider or profile settings. */
  username: string;
  /** Primary email address associated with the user account. */
  email: string;
  /** Optional given name if provided by the OAuth profile. */
  firstName?: string;
  /** Optional family name if provided by the OAuth profile. */
  lastName?: string;
}

export interface AuthResponseDto {
  /** Primary camelCase token field for new clients. */
  accessToken: string;
  /** Legacy snake_case token field retained for backwards compatibility. */
  access_token?: string;
  /** Hard-coded token type string so clients can validate expectations. */
  tokenType: "access";
  /** Number of seconds until the access token expires. */
  expiresInSeconds: number;
  user: AuthResponseUserDto;
}

export interface DevResetOnboardingDto {
  /** @example "maestro.user@white-gi.local" */
  email: string;
}

export interface AccountResponseDto {
  /**
   * Unique user identifier
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Immutable after onboarding completes
   * @example "gordonr"
   */
  username: string;
  /**
   * User's first name
   * @minLength 1
   * @maxLength 255
   * @example "John"
   */
  firstName: string;
  /**
   * User's last name
   * @minLength 1
   * @maxLength 255
   * @example "Doe"
   */
  lastName: string;
  /**
   * User's email address (lowercased)
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * BJJ belt color or null
   * @example "BLUE"
   */
  belt?: "WHITE" | "BLUE" | "PURPLE" | "BROWN" | "BLACK" | null;
  /**
   * Stripe count within current belt ('0'-'4') or null
   * @example "2"
   */
  rank?: "0" | "1" | "2" | "3" | "4" | null;
  gender?: "MALE" | "FEMALE" | null;
  /**
   * Date of birth as YYYY-MM-DD, or null
   * @format date
   * @example "1998-03-14"
   */
  birthday: string | null;
  /**
   * Date training started as YYYY-MM-DD, or null
   * @format date
   * @example "2015-06-01"
   */
  trainingStartedOn: string | null;
  /**
   * Free-text location, or null
   * @example "Rio de Janeiro"
   */
  location: string | null;
  /**
   * Body weight in grams, or null
   * @example 75000
   */
  weightGrams: number | null;
  /**
   * Height in millimetres, or null
   * @example 1800
   */
  heightMm: number | null;
  /**
   * Account creation timestamp
   * @format date-time
   * @example "2025-01-15T10:30:00Z"
   */
  createdAt: string;
  /**
   * Account last update timestamp
   * @format date-time
   * @example "2025-11-09T14:22:00Z"
   */
  updatedAt: string;
}

export interface UpdateAccountDto {
  /**
   * User's first name. Trimmed and HTML-escaped BEFORE the 1-255 length check, so the length checked is the sanitised one, which may be longer or shorter than what was sent. Markup is escaped rather than deleted, which lengthens it: `<b>` is stored as `&lt;b&gt;` (3 characters in, 9 stored) and `Ben & Jerry` as `Ben &amp; Jerry` (11 in, 15 stored), so a 255-character value carrying `<` or `&` can be rejected for length. HTML entities are resolved, which shortens it: a value that is only `&nbsp;` sanitises to nothing and is rejected. Reads, this response and `GET /api/account`, decode `&amp;`, `&lt;` and `&gt;` back, so plain text and markup come back as typed (`Ben & Jerry`, `<b>`). Text that already contained an entity does not: `&copy;` reads back as `©`, `O&#39;Brien` as `O'Brien` and `Ben &amp; Jerry` as `Ben & Jerry`.
   * @minLength 1
   * @maxLength 255
   * @example "John"
   */
  firstName?: string;
  /**
   * User's last name. Trimmed and HTML-escaped BEFORE the 1-255 length check, so the length checked is the sanitised one, which may be longer or shorter than what was sent. Markup is escaped rather than deleted, which lengthens it: `<b>` is stored as `&lt;b&gt;` (3 characters in, 9 stored) and `Ben & Jerry` as `Ben &amp; Jerry` (11 in, 15 stored), so a 255-character value carrying `<` or `&` can be rejected for length. HTML entities are resolved, which shortens it: a value that is only `&nbsp;` sanitises to nothing and is rejected. Reads, this response and `GET /api/account`, decode `&amp;`, `&lt;` and `&gt;` back, so plain text and markup come back as typed (`Ben & Jerry`, `<b>`). Text that already contained an entity does not: `&copy;` reads back as `©`, `O&#39;Brien` as `O'Brien` and `Ben &amp; Jerry` as `Ben & Jerry`.
   * @minLength 1
   * @maxLength 255
   * @example "Doe"
   */
  lastName?: string;
  /**
   * BJJ belt color (progression level) or null
   * @example "BLUE"
   */
  belt?: "WHITE" | "BLUE" | "PURPLE" | "BROWN" | "BLACK" | null;
  /**
   * Stripe count within current belt ('0'-'4') or null
   * @example "2"
   */
  rank?: "0" | "1" | "2" | "3" | "4" | null;
  gender?: "MALE" | "FEMALE" | null;
  /**
   * Date of birth as a YYYY-MM-DD calendar date, or null to clear it. Stored encrypted at rest. Must not be in the future and must be within the last 120 years. A timestamp (`1998-03-14T00:00:00Z`) is rejected: this is a calendar date, not an instant.
   * @format date
   * @example "1998-03-14"
   */
  birthday?: string | null;
  /**
   * The date training started, as a YYYY-MM-DD calendar date, or null to clear it. Must not be in the future. There is no lower bound: the 120-year floor is on birthday only.
   * @format date
   * @example "2015-06-01"
   */
  trainingStartedOn?: string | null;
  /**
   * Free-text location, or null to clear it; omit the key to leave it unchanged. Trimmed and sanitized before the 1-255 length check, so the length checked is the sanitized one, which may be longer or shorter than what was sent. `<`, `>` and a bare `&` are escaped rather than deleted, which lengthens it: `&` is stored as `&amp;`, so 52 `&` characters measure 260 and are rejected although 52 is under maxLength. HTML entities are resolved, which shortens it: `&copy;` is stored as `©`. A value left empty by sanitizing is rejected exactly as the empty string is, so whitespace only and `&nbsp;` are rejected, and null is the only way to clear the field. A read decodes `&amp;`, `&lt;` and `&gt;` back, so plain text and markup come back as typed (`Ben & Jerry`, `a > b`). Text that already contained an entity does not: `&copy;` reads back as `©`, `O&#39;Brien` as `O'Brien` and `&amp;lt;` as `&lt;`.
   * @minLength 1
   * @maxLength 255
   * @example "Rio de Janeiro"
   */
  location?: string | null;
  /**
   * Body weight in GRAMS, or null to clear it. Grams, not kilograms and not pounds: imperial conversion is a display-layer concern. The accepted range is 20000-500000 (20 kg to 500 kg), which mirrors the users_weight_grams_check database constraint exactly.
   * @min 20000
   * @max 500000
   * @example 75000
   */
  weightGrams?: number | null;
  /**
   * Height in MILLIMETRES, or null to clear it. The accepted range is 500-2500 (50 cm to 250 cm), which mirrors the users_height_mm_check database constraint exactly.
   * @min 500
   * @max 2500
   * @example 1800
   */
  heightMm?: number | null;
}

export interface UsernameAvailabilityResponseDto {
  /**
   * True when the handle is free, or is the one the caller already holds.
   * @example true
   */
  available: boolean;
}

export interface SetUsernameDto {
  /**
   * Member handle. Lowercase letters, numbers and underscores.
   * @minLength 3
   * @maxLength 30
   * @pattern ^[a-z0-9_]{3,30}$
   * @example "gordonr"
   */
  username: string;
}

export interface CreateMoveDto {
  /**
   * Name of the BJJ move
   * @minLength 1
   * @maxLength 255
   * @example "Armbar from Guard"
   */
  name: string;
  /**
   * Detailed description of the move
   * @example "Classic armbar setup from closed guard position with proper hip movement"
   */
  description: string;
  /**
   * Video URL for the move (YouTube, Instagram, etc.)
   * @example "https://youtube.com/watch?v=example"
   */
  url?: string;
  /**
   * Thumbnail image URL for the video
   * @example "https://img.youtube.com/vi/example/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Duration of the video in seconds, or null for none. Stored only on a move that has a link: a move without one stores null, whatever is sent.
   * @min 0
   * @max 86400
   * @example 180
   */
  durationSeconds?: number | null;
}

export interface Series {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Soft delete timestamp
   * @format date-time
   * @example null
   */
  deletedAt?: string;
  /**
   * User who owns this series
   * @example "uuid-string"
   */
  userId: string;
  /**
   * Name of the BJJ series
   * @minLength 1
   * @maxLength 255
   * @example "Closed Guard Attacks"
   */
  name: string;
  /**
   * Detailed description of the series
   * @example "Complete series of attacks from closed guard with multiple pathways"
   */
  description: string;
}

export interface Move {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Soft delete timestamp
   * @format date-time
   * @example null
   */
  deletedAt?: string;
  /**
   * User who owns this move
   * @example "uuid-string"
   */
  userId: string;
  /**
   * Name of the BJJ move
   * @minLength 1
   * @maxLength 255
   * @example "Armbar from Guard"
   */
  name: string;
  /**
   * Detailed description of the move
   * @example "Classic armbar setup from closed guard position with proper hip movement"
   */
  description: string;
  /**
   * Video URL for the move (YouTube, Instagram, etc.)
   * @example "https://youtube.com/watch?v=example"
   */
  url?: string;
  /**
   * Thumbnail image URL for the video
   * @example "https://img.youtube.com/vi/example/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Duration of the video in seconds
   * @example 180
   */
  durationSeconds?: number;
}

export interface MoveConnectionResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Series ID that scopes this connection
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  seriesId: string;
  /**
   * Starting move ID of the connection
   * @example "550e8400-e29b-41d4-a716-446655440001"
   */
  fromMoveId: string;
  /**
   * Destination move ID of the connection
   * @example "550e8400-e29b-41d4-a716-446655440002"
   */
  toMoveId: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** The series, when the endpoint loads it: on GET /move-connections/{id} whatever the request; on GET /move-connections, GET /move-connections/series/{seriesId} and GET /move-connections/move/{moveId} only when includeRelations is true. Left out by every other response that carries a connection, including POST /move-connections and the connections inside a series. */
  series?: Series;
  /** The move the connection starts at, when the endpoint loads it and the caller owns that move: on GET /move-connections/{id} whatever the request; on GET /move-connections, GET /move-connections/series/{seriesId} and GET /move-connections/move/{moveId} only when includeRelations is true. Left out when the move belongs to another member or has been deleted, even with includeRelations=true, and by every other response, including POST /move-connections and the connections inside a series. fromMoveId is sent in every case. */
  fromMove?: Move;
  /** The move the connection ends at, when the endpoint loads it and the caller owns that move: on GET /move-connections/{id} whatever the request; on GET /move-connections, GET /move-connections/series/{seriesId} and GET /move-connections/move/{moveId} only when includeRelations is true. Left out when the move belongs to another member or has been deleted, even with includeRelations=true, and by every other response, including POST /move-connections and the connections inside a series. toMoveId is sent in every case. */
  toMove?: Move;
}

export interface TagResponseDto {
  /**
   * Unique identifier for the tag
   * @example "f47ac10b-58cc-4372-a567-0e02b2c3d479"
   */
  id: string;
  /**
   * ID of the user who created this tag
   * @example "f47ac10b-58cc-4372-a567-0e02b2c3d479"
   */
  userId: string;
  /**
   * Name of the tag
   * @example "Guard"
   */
  name: string;
  /**
   * Description of the tag
   * @example "All guard-related techniques and positions"
   */
  description?: string;
  /**
   * Color hex code for the tag
   * @example "#0033A0"
   */
  color?: string;
  /**
   * When the tag was created
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  createdAt: string;
  /**
   * When the tag was last updated
   * @format date-time
   * @example "2024-01-15T10:30:00Z"
   */
  updatedAt: string;
  /** The live taggings that apply this tag, each without its own `tag`, when the endpoint loads them: on GET /tags with includeRelations=true, and not when includeRelations is left off. Left out by POST /tags, GET /tags/search, GET /tags/{id} and PUT /tags/{id}, and by the tag inside a tagging. */
  taggings?: TaggingResponseDto[];
}

export interface TaggingResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Tag that is being applied
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  tagId: string;
  /**
   * Type of entity being tagged
   * @example "move"
   */
  taggableType: "move" | "series";
  /**
   * ID of the entity being tagged (move or series)
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  taggableId: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** The applied tag, when the endpoint loads it: on GET /taggings/entity/{entityType}/{entityId} and POST /taggings/entity/{entityType}/{entityId}/tags whatever the request, and on every tagging inside a move or a series; on GET /taggings with includeRelations=true, and not when includeRelations is left off. Left out by POST /taggings, GET /taggings/{id} and PUT /taggings/{id}, and by the taggings inside a tag. tagId is sent in every case. */
  tag?: TagResponseDto;
}

export interface NestedSeriesResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * User who owns this series
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  userId: string;
  /**
   * Name of the BJJ series
   * @example "Guard Passing Series"
   */
  name: string;
  /**
   * Detailed description of the series
   * @example "Complete guard passing series covering fundamental concepts and advanced techniques"
   */
  description: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** The live series-moves in this series, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  seriesMoves?: SeriesMoveResponseDto[];
  /** The live move connections in this series, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  moveConnections?: MoveConnectionResponseDto[];
  /** The series' tags, one tagging per tag, each carrying its `tag`, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  taggings?: TaggingResponseDto[];
}

export interface NestedMoveResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * User who owns this move
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  userId: string;
  /**
   * Name of the BJJ move
   * @example "Armbar from Guard"
   */
  name: string;
  /**
   * Detailed description of the move
   * @example "Classic armbar setup from closed guard position with proper hip movement"
   */
  description: string;
  /**
   * Video URL for the move (YouTube, Instagram, etc.)
   * @example "https://youtube.com/watch?v=example"
   */
  url?: string;
  /**
   * Thumbnail image URL for the video
   * @example "https://img.youtube.com/vi/example/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Duration of the video in seconds
   * @example 180
   */
  durationSeconds?: number;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** The live series-moves that place this move in a series, when the endpoint loads them: on GET /moves/{id} and GET /moves with includeRelations=true, and not when includeRelations is left off. Left out by POST /moves and PUT /moves/{id}, and by every move nested inside a series-move. */
  seriesMoves?: SeriesMoveResponseDto[];
  /** The move's tags, one tagging per tag, each carrying its `tag`, when the endpoint loads them. On a top-level move: on GET /moves/{id} and GET /moves with includeRelations=true, and not when includeRelations is left off; left out by POST /moves and PUT /moves/{id}. On a move nested inside a series-move: on PATCH /series/{id}/positions whatever the request and on GET /series/{id} with includeRelations=true; left out everywhere else, including GET /series and the /series-moves routes. */
  taggings?: TaggingResponseDto[];
}

export interface SeriesMoveResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * Series that contains this move
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  seriesId: string;
  /**
   * Move that belongs to the series
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  moveId: string;
  /**
   * Horizontal position used for custom layouts
   * @example 125.5
   */
  positionX?: number | null;
  /**
   * Vertical position used for custom layouts
   * @example 240.75
   */
  positionY?: number | null;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /** The parent series, when the endpoint loads it: on GET /series-moves/{id} and GET /series-moves/series/{seriesId}/moves whatever the request; on GET /series-moves, GET /moves and GET /moves/{id} only when includeRelations is true. Left out by every other response that carries a series-move, including POST /series-moves and the series-moves inside a series. null on GET /moves and GET /moves/{id} for an entry that is live while its series has been deleted. */
  series?: NestedSeriesResponseDto | null;
  /** The linked move, when the endpoint loads it: on GET /series-moves/{id}, GET /series-moves/series/{seriesId}/moves and PATCH /series/{id}/positions whatever the request; on GET /series-moves, GET /series and GET /series/{id} only when includeRelations is true. Left out by POST /series-moves and the series-moves inside a move. For an entry that is live while its move has been deleted, GET /series, GET /series/{id} and PATCH /series/{id}/positions send null, and the /series-moves routes leave it out. Its `taggings` are populated only on GET /series/{id}?includeRelations=true and PATCH /series/{id}/positions; every other endpoint leaves them out. */
  move?: NestedMoveResponseDto | null;
}

export interface MoveResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * User who owns this move
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  userId: string;
  /**
   * Name of the BJJ move
   * @example "Armbar from Guard"
   */
  name: string;
  /**
   * Detailed description of the move
   * @example "Classic armbar setup from closed guard position with proper hip movement"
   */
  description: string;
  /**
   * Video URL for the move (YouTube, Instagram, etc.)
   * @example "https://youtube.com/watch?v=example"
   */
  url?: string;
  /**
   * Thumbnail image URL for the video
   * @example "https://img.youtube.com/vi/example/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Duration of the video in seconds
   * @example 180
   */
  durationSeconds?: number;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Whether the requesting member has favourited this move
   * @example false
   */
  isFavourite: boolean;
  /** The live series-moves that place this move in a series, when the endpoint loads them: on GET /moves/{id} and GET /moves with includeRelations=true, and not when includeRelations is left off. Left out by POST /moves and PUT /moves/{id}, and by every move nested inside a series-move. */
  seriesMoves?: SeriesMoveResponseDto[];
  /** The move's tags, one tagging per tag, each carrying its `tag`, when the endpoint loads them. On a top-level move: on GET /moves/{id} and GET /moves with includeRelations=true, and not when includeRelations is left off; left out by POST /moves and PUT /moves/{id}. On a move nested inside a series-move: on PATCH /series/{id}/positions whatever the request and on GET /series/{id} with includeRelations=true; left out everywhere else, including GET /series and the /series-moves routes. */
  taggings?: TaggingResponseDto[];
}

export interface MoveListResponseDto {
  /** Array of moves */
  moves: MoveResponseDto[];
  /**
   * Total number of moves matching the query
   * @example 150
   */
  total: number;
  /**
   * Number of results returned in this response
   * @example 20
   */
  count: number;
  /**
   * Maximum number of results per page
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface UpdateMoveDto {
  /**
   * Name of the BJJ move
   * @minLength 1
   * @maxLength 255
   * @example "Armbar from Guard"
   */
  name?: string;
  /**
   * Detailed description of the move
   * @example "Classic armbar setup from closed guard position with proper hip movement"
   */
  description?: string;
  /**
   * Video URL for the move (YouTube, Instagram, etc.)
   * @example "https://youtube.com/watch?v=example"
   */
  url?: string;
  /**
   * Thumbnail image URL for the video
   * @example "https://img.youtube.com/vi/example/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Duration of the video in seconds, or null to clear it. Stored only on a move that has a link: a move without one stores null, whatever is sent.
   * @min 0
   * @max 86400
   * @example 180
   */
  durationSeconds?: number | null;
}

export interface CreateMoveSourceDto {
  /**
   * ID of the move this source belongs to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  moveId: string;
  /**
   * Type of source for the move creation
   * @example "sms"
   */
  sourceType: "manual" | "sms";
  /**
   * Original URL of the move content
   * @maxLength 500
   * @example "https://www.reddit.com/r/bjj/comments/abc123/pass_setup_walkthrough/"
   */
  originalUrl?: string;
  /**
   * Platform where the content originated. Supported platforms: YouTube, Instagram, TikTok, Facebook, Vimeo, Reddit.
   * @example "reddit"
   */
  platform?:
    | "youtube"
    | "instagram"
    | "facebook"
    | "tiktok"
    | "vimeo"
    | "reddit";
  /**
   * Additional metadata about the source
   * @example {"title":"Amazing BJJ Technique","channelName":"BJJ Academy","originalDuration":"PT3M45S"}
   */
  metadata?: object;
}

export interface MoveSourceResponseDto {
  /**
   * Unique identifier of the move source
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * ID of the associated move
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174001"
   */
  moveId: string;
  /**
   * Type of source for the move creation
   * @example "sms"
   */
  sourceType: "manual" | "sms";
  /**
   * Original URL of the move content
   * @example "https://www.reddit.com/r/bjj/comments/abc123/pass_setup_walkthrough/"
   */
  originalUrl?: string;
  /**
   * Platform where the content originated. Supported platforms: YouTube, Instagram, TikTok, Facebook, Vimeo, Reddit.
   * @example "reddit"
   */
  platform?:
    | "youtube"
    | "instagram"
    | "facebook"
    | "tiktok"
    | "vimeo"
    | "reddit";
  /**
   * Additional metadata about the source
   * @example {"title":"Amazing BJJ Technique","channelName":"BJJ Academy","originalDuration":"PT3M45S"}
   */
  metadata?: object;
  /**
   * Timestamp when the source was created
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Timestamp when the source was last updated
   * @format date-time
   * @example "2024-01-02T00:00:00.000Z"
   */
  updatedAt: string;
}

export interface MoveSourceListResponseDto {
  /** Array of move sources */
  moveSources: MoveSourceResponseDto[];
  /**
   * Total number of sources available
   * @example 100
   */
  total: number;
  /**
   * Number of sources returned in this response
   * @example 10
   */
  count: number;
  /**
   * Maximum number of results requested
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface UpdateMoveSourceDto {
  /**
   * Type of source for the move creation
   * @example "manual"
   */
  sourceType?: "manual" | "sms";
  /**
   * Original URL of the move content
   * @maxLength 500
   * @example "https://www.reddit.com/r/bjj/comments/abc123/pass_setup_walkthrough/"
   */
  originalUrl?: string;
  /**
   * Platform where the content originated. Supported platforms: YouTube, Instagram, TikTok, Facebook, Vimeo, Reddit.
   * @example "reddit"
   */
  platform?:
    | "youtube"
    | "instagram"
    | "facebook"
    | "tiktok"
    | "vimeo"
    | "reddit";
  /**
   * Additional metadata about the source
   * @example {"title":"Updated BJJ Technique","tags":["bjj","guard","submission"]}
   */
  metadata?: object;
}

export interface CreateSeriesDto {
  /**
   * Name of the BJJ series
   * @minLength 1
   * @maxLength 255
   * @example "Guard Passing Series"
   */
  name: string;
  /**
   * Detailed description of the series
   * @example "Complete guard passing series covering fundamental concepts and advanced techniques"
   */
  description: string;
}

export interface SeriesResponseDto {
  /**
   * Unique identifier
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  id: string;
  /**
   * User who owns this series
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  userId: string;
  /**
   * Name of the BJJ series
   * @example "Guard Passing Series"
   */
  name: string;
  /**
   * Detailed description of the series
   * @example "Complete guard passing series covering fundamental concepts and advanced techniques"
   */
  description: string;
  /**
   * Creation timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Whether the requesting member has favourited this series
   * @example false
   */
  isFavourite: boolean;
  /** The live series-moves in this series, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  seriesMoves?: SeriesMoveResponseDto[];
  /** The live move connections in this series, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  moveConnections?: MoveConnectionResponseDto[];
  /** The series' tags, one tagging per tag, each carrying its `tag`, when the endpoint loads them: on PATCH /series/{id}/positions whatever the request; on GET /series/{id} and GET /series with includeRelations=true, and not when includeRelations is left off. Left out by POST /series and PUT /series/{id}, and by every series nested inside a series-move. */
  taggings?: TaggingResponseDto[];
}

export interface SeriesListResponseDto {
  /** Array of series */
  series: SeriesResponseDto[];
  /**
   * Total number of series matching the query
   * @example 150
   */
  total: number;
  /**
   * Number of results returned in this response
   * @example 20
   */
  count: number;
  /**
   * Maximum number of results per page
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface UpdateSeriesDto {
  /**
   * Name of the BJJ series
   * @minLength 1
   * @maxLength 255
   * @example "Guard Passing Series"
   */
  name?: string;
  /**
   * Detailed description of the series
   * @example "Complete guard passing series covering fundamental concepts and advanced techniques"
   */
  description?: string;
}

export interface SeriesMovePositionUpdateDto {
  /**
   * Identifier of the series-move relationship to update
   * @example "a3c51763-c1a5-4b6c-aefa-0a8b3a77b0c1"
   */
  seriesMoveId: string;
  /**
   * Horizontal coordinate for the move node
   * @example 125.5
   */
  positionX: number;
  /**
   * Vertical coordinate for the move node
   * @example 240.75
   */
  positionY: number;
}

export interface UpdateSeriesPositionsDto {
  /** Array of move position updates */
  positions: SeriesMovePositionUpdateDto[];
}

export interface CreateSeriesMoveDto {
  /**
   * Series to add the move to
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  seriesId: string;
  /**
   * Move to add to the series
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  moveId: string;
  /**
   * Optional explicit horizontal position (flow coordinates). Paired with positionY: must be supplied together or both omitted. When omitted, the server scans for a non-overlapping box relative to the most-recently-added move in the series.
   * @example 0
   */
  positionX?: number | null;
  /**
   * Optional explicit vertical position (flow coordinates). Paired with positionX: must be supplied together or both omitted. When omitted, the server scans for a non-overlapping box relative to the most-recently-added move in the series.
   * @example 0
   */
  positionY?: number | null;
}

export interface SeriesMoveListResponseDto {
  /** Array of series-move relationships */
  seriesMoves: SeriesMoveResponseDto[];
  /**
   * Total number of relationships matching the query
   * @example 25
   */
  total: number;
  /**
   * Number of results returned in this response
   * @example 20
   */
  count: number;
  /**
   * Maximum number of results per page
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface CreateTagDto {
  /**
   * Name of the tag
   * @minLength 1
   * @maxLength 100
   * @example "Guard"
   */
  name: string;
  /**
   * Description of the tag
   * @maxLength 255
   * @example "All guard-related techniques and positions"
   */
  description?: string;
  /**
   * Color hex code for the tag
   * @maxLength 7
   * @pattern ^#[0-9A-Fa-f]{6}$
   * @example "#0033A0"
   */
  color?: string;
}

export interface TagListResponseDto {
  /** List of tags matching the query */
  tags: TagResponseDto[];
  /**
   * Total number of tags available
   * @example 42
   */
  total: number;
  /**
   * Number of tags returned in this response
   * @example 10
   */
  count: number;
  /**
   * Number of tags skipped for pagination
   * @example 0
   */
  offset: number;
}

export interface UpdateTagDto {
  /**
   * Name of the tag
   * @minLength 1
   * @maxLength 100
   * @example "Guard Techniques"
   */
  name?: string;
  /**
   * Description of the tag
   * @maxLength 255
   * @example "Updated description for guard techniques"
   */
  description?: string;
  /**
   * Color hex code for the tag
   * @maxLength 7
   * @pattern ^#[0-9A-Fa-f]{6}$
   * @example "#6B3FA0"
   */
  color?: string;
}

export interface CreateTaggingDto {
  /**
   * Tag to apply to the entity
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  tagId: string;
  /**
   * Type of entity being tagged
   * @example "move"
   */
  taggableType: "move" | "series";
  /**
   * ID of the entity being tagged (move or series)
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  taggableId: string;
}

export interface TaggingListResponseDto {
  /** Array of taggings */
  taggings: TaggingResponseDto[];
  /**
   * Total number of taggings matching the query
   * @example 75
   */
  total: number;
  /**
   * Number of results returned in this response
   * @example 20
   */
  count: number;
  /**
   * Maximum number of results per page
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface UpdateTaggingDto {
  /**
   * Tag to apply to the entity
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  tagId?: string;
  /**
   * Type of entity being tagged
   * @example "move"
   */
  taggableType?: "move" | "series";
  /**
   * ID of the entity being tagged (move or series)
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  taggableId?: string;
}

export interface EntityTagsResponseDto {
  /**
   * Entity ID
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  entityId: string;
  /**
   * Entity type
   * @example "move"
   */
  entityType: "move" | "series";
  /** Array of taggings for this entity */
  taggings: TaggingResponseDto[];
  /**
   * Total number of tags applied to this entity
   * @example 3
   */
  totalTags: number;
}

export interface ApplyTagsToEntityDto {
  /**
   * Array of tag IDs to apply to the entity
   * @example ["550e8400-e29b-41d4-a716-446655440000","660e8400-e29b-41d4-a716-446655440001"]
   */
  tagIds: string[];
}

export interface RemoveTagFromEntityDto {
  /**
   * Tag ID to remove from the entity
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  tagId: string;
}

export interface CreateMoveConnectionDto {
  /**
   * Series ID that scopes this connection
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  seriesId: string;
  /**
   * Starting move ID of the connection
   * @example "550e8400-e29b-41d4-a716-446655440001"
   */
  fromMoveId: string;
  /**
   * Destination move ID of the connection
   * @example "550e8400-e29b-41d4-a716-446655440002"
   */
  toMoveId: string;
}

export interface MoveConnectionListResponseDto {
  /** Array of move connections */
  connections: MoveConnectionResponseDto[];
  /**
   * Total number of connections matching the query
   * @example 150
   */
  total: number;
  /**
   * Number of results returned in this response
   * @example 20
   */
  count: number;
  /**
   * Maximum number of results per page
   * @example 20
   */
  limit: number;
  /**
   * Number of results skipped
   * @example 0
   */
  offset: number;
}

export interface FavouriteStateResponseDto {
  /** @example "move" */
  entityType: "move" | "series";
  /** @example "f47ac10b-58cc-4372-a567-0e02b2c3d479" */
  entityId: string;
  /** @example true */
  isFavourite: boolean;
}

export interface SlimMoveDto {
  /**
   * Move ID
   * @format uuid
   */
  id: string;
  /** Move name */
  name: string;
  /** Move description */
  description: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface SlimSeriesDto {
  /**
   * Series ID
   * @format uuid
   */
  id: string;
  /** Series name */
  name: string;
  /** Series description */
  description?: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface SlimTagDto {
  /**
   * Tag ID
   * @format uuid
   */
  id: string;
  /** Tag name */
  name: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt: string;
}

export interface DashboardSummaryResponseDto {
  /** Total moves for the authenticated user */
  movesTotal: number;
  /** Total series for the authenticated user */
  seriesTotal: number;
  /** Total tags for the authenticated user */
  tagsTotal: number;
  /** Count of moves created in the last 7 days */
  recentlyAddedCount: number;
  /** Up to 5 most-recently-created moves */
  recentMoves: SlimMoveDto[];
  /** Up to 5 most-recently-created series */
  recentSeries: SlimSeriesDto[];
  /** Up to 5 most-recently-created tags */
  recentTags: SlimTagDto[];
}

export interface VideoMetadataLookupDto {
  /**
   * The video URL to look up
   * @maxLength 500
   * @example "https://www.youtube.com/watch?v=abc123xyz89"
   */
  url: string;
}

export interface VideoMetadataResponseDto {
  /**
   * Always present. Derived from the URL when no remote title is available, or when the remote title escapes to nothing (one that is only `&nbsp;`, say). Shortened until the raw string is at most 500 UTF-16 code units and its @TrimAndSanitize-escaped form is at most 255, so it is within the 1 to 255 CreateMoveDto.name accepts.
   * @maxLength 500
   * @example "Armbar From Guard"
   */
  name: string;
  /**
   * Never guaranteed, for any platform. It comes only from the provider oEmbed answer, so it is absent whenever that request fails or the answer carries none; Instagram and Facebook are asked with an access token that is empty unless the server is configured with one. Also absent when the URL is not https, or when it is longer than 500 UTF-16 code units either raw or after the @TrimAndSanitize escaping CreateMoveDto.thumbnailUrl applies before its 500-character @Length check. A URL that fails is omitted, never truncated.
   * @maxLength 500
   * @example "https://img.youtube.com/vi/abc123/maxresdefault.jpg"
   */
  thumbnailUrl?: string;
  /**
   * Best-effort. Only Vimeo oEmbed carries a duration; every other platform omits it. When present it is a whole number of seconds in 1..86400: a fractional or out-of-range value from the provider is rounded and clamped server-side before this response is built.
   * @min 1
   * @max 86400
   * @example 312
   */
  durationSeconds?: number;
  /**
   * Derived from the URL server-side, never supplied by the caller.
   * @example "youtube"
   */
  platform:
    | "youtube"
    | "instagram"
    | "facebook"
    | "tiktok"
    | "vimeo"
    | "reddit";
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://dev.white-gi.com:443/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title White Gi API
 * @version 1.1.0
 * @baseUrl https://dev.white-gi.com:443/api
 * @contact
 *
 * OAuth-only authentication for the White Gi training platform. All protected routes require Authorization: Bearer <accessToken> issued during login.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Returns `ok` plus the commit this process was deployed from.
     *
     * @tags health
     * @name HealthControllerGetHealth
     * @summary Liveness, and which deploy is answering
     * @request GET:/api/health
     * @secure
     */
    healthControllerGetHealth: (params: RequestParams = {}) =>
      this.request<HealthResponseDto, any>({
        path: `/api/health`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerGoogleAuth
     * @request GET:/api/auth/google
     * @secure
     */
    authControllerGoogleAuth: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/google`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerGoogleCallback
     * @request GET:/api/auth/google/redirect
     * @secure
     */
    authControllerGoogleCallback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/google/redirect`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerAppleAuth
     * @request GET:/api/auth/apple
     * @secure
     */
    authControllerAppleAuth: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/apple`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerAppleCallback
     * @request POST:/api/auth/apple/redirect
     * @secure
     */
    authControllerAppleCallback: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/apple/redirect`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Mints a short-lived signed state. Hand it to GET /api/auth/google?state=… or /api/auth/apple?state=…; the address the provider asserts becomes the account's email. Writes nothing and discloses nothing about any address.
     *
     * @tags auth
     * @name AuthControllerStartEmailChange
     * @summary Begin an email change
     * @request POST:/api/auth/email-change/start
     * @secure
     */
    authControllerStartEmailChange: (
      data: EmailChangeStartDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailChangeStartResponseDto, void>({
        path: `/api/auth/email-change/start`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerCompleteEmailChange
     * @summary Apply an email change the provider just asserted
     * @request POST:/api/auth/email-change/complete
     * @secure
     */
    authControllerCompleteEmailChange: (
      data: EmailChangeCompleteDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailChangeResultDto, void>({
        path: `/api/auth/email-change/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the authenticated user's profile information. Requires valid Authorization header with a JWT access token.
     *
     * @tags auth
     * @name AuthControllerGetProfile
     * @summary Get current user profile
     * @request GET:/api/auth/me
     * @secure
     */
    authControllerGetProfile: (params: RequestParams = {}) =>
      this.request<MeResponseDto, void>({
        path: `/api/auth/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Exchanges the caller’s access token for an access token used by the embedded series-graph WebView, with the same authority and the caller’s `iat`. It lives AUTH_EMBED_TOKEN_TTL_SECONDS (300 by default), or less when the caller’s token expires sooner: it never outlives that token. An embed token cannot itself be exchanged.
     *
     * @tags auth
     * @name AuthControllerEmbedToken
     * @summary Mint a short-lived access token for the series-graph WebView embed
     * @request POST:/api/auth/embed-token
     * @secure
     */
    authControllerEmbedToken: (params: RequestParams = {}) =>
      this.request<EmbedTokenResponseDto, void>({
        path: `/api/auth/embed-token`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Only available when ENABLE_TEST_LOGIN=true.
     *
     * @tags auth
     * @name AuthControllerTestLogin
     * @summary Dev-only: mint a token for any email without OAuth
     * @request POST:/api/auth/dev-login
     * @secure
     */
    authControllerTestLogin: (data: DevLoginDto, params: RequestParams = {}) =>
      this.request<AuthResponseDto, void>({
        path: `/api/auth/dev-login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Only available when ENABLE_TEST_LOGIN=true. Called from a Maestro runScript so the onboarding flows declare their own precondition rather than depending on database state left over from the previous run.
     *
     * @tags auth
     * @name AuthControllerDevResetOnboarding
     * @summary Dev-only: return a test user to a pre-onboarding state
     * @request POST:/api/auth/dev-reset-onboarding
     * @secure
     */
    authControllerDevResetOnboarding: (
      data: DevResetOnboardingDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/auth/dev-reset-onboarding`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves the account profile for the currently authenticated user including personal information and BJJ progression tracking (belt and rank).
     *
     * @tags account
     * @name AccountControllerGetAccount
     * @summary Get authenticated user's account information
     * @request GET:/api/account
     * @secure
     */
    accountControllerGetAccount: (params: RequestParams = {}) =>
      this.request<AccountResponseDto, void>({
        path: `/api/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the account profile for the currently authenticated user. Supports partial updates - only provided fields will be updated. Validates belt enum values and rank values.
     *
     * @tags account
     * @name AccountControllerUpdateAccount
     * @summary Update authenticated user's account information
     * @request PUT:/api/account
     * @secure
     */
    accountControllerUpdateAccount: (
      data: UpdateAccountDto,
      params: RequestParams = {},
    ) =>
      this.request<AccountResponseDto, void>({
        path: `/api/account`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reports the caller's own current handle as available, so a member returning to an unfinished signup is not told the handle they already hold is taken. Rate limited.
     *
     * @tags account
     * @name AccountControllerCheckUsernameAvailability
     * @summary Check whether a handle is free
     * @request GET:/api/account/username/availability
     * @secure
     */
    accountControllerCheckUsernameAvailability: (
      query: {
        /**
         * Member handle. Lowercase letters, numbers and underscores.
         * @minLength 3
         * @maxLength 30
         * @pattern ^[a-z0-9_]{3,30}$
         * @example "gordonr"
         */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsernameAvailabilityResponseDto, void>({
        path: `/api/account/username/availability`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Writable only while onboarding is incomplete. Immutable once onboarding completes.
     *
     * @tags account
     * @name AccountControllerSetUsername
     * @summary Set the handle
     * @request PATCH:/api/account/username
     * @secure
     */
    accountControllerSetUsername: (
      data: SetUsernameDto,
      params: RequestParams = {},
    ) =>
      this.request<AccountResponseDto, void>({
        path: `/api/account/username`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Re-reads the member row and verifies gender and belt rather than trusting the client. Idempotent — a retry after a dropped response returns the same payload and does not move the recorded completion time.
     *
     * @tags account
     * @name AccountControllerCompleteOnboarding
     * @summary Mark onboarding complete after verifying the required fields
     * @request POST:/api/account/onboarding/complete
     * @secure
     */
    accountControllerCompleteOnboarding: (params: RequestParams = {}) =>
      this.request<MeResponseDto, void>({
        path: `/api/account/onboarding/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new BJJ move with optional video URL and metadata
     *
     * @tags moves
     * @name MovesControllerCreate
     * @summary Create a new move
     * @request POST:/api/moves
     * @secure
     */
    movesControllerCreate: (data: CreateMoveDto, params: RequestParams = {}) =>
      this.request<MoveResponseDto, void>({
        path: `/api/moves`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all moves for the authenticated user with optional filtering and pagination
     *
     * @tags moves
     * @name MovesControllerFindAll
     * @summary Get all moves
     * @request GET:/api/moves
     * @secure
     */
    movesControllerFindAll: (
      query?: {
        /**
         * Search text to filter moves by name or description
         * @example "armbar"
         */
        searchText?: string;
        /**
         * Filter by specific URL
         * @example "https://youtube.com/watch?v=example"
         */
        url?: string;
        /**
         * Set to true to load each move's seriesMoves and taggings. Without it, neither is sent.
         * @default false
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Restrict results to the member's favourites
         * @default false
         * @example true
         */
        favouritesOnly?: boolean;
        /**
         * Maximum number of results to return (1-100)
         * @min 1
         * @max 100
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * Number of results to skip
         * @min 0
         * @default 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveListResponseDto, any>({
        path: `/api/moves`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific move by its ID
     *
     * @tags moves
     * @name MovesControllerFindById
     * @summary Get move by ID
     * @request GET:/api/moves/{id}
     * @secure
     */
    movesControllerFindById: (
      id: string,
      query?: {
        /** Include related data (seriesMoves, taggings) */
        includeRelations?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveResponseDto, void>({
        path: `/api/moves/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing move
     *
     * @tags moves
     * @name MovesControllerUpdate
     * @summary Update move
     * @request PUT:/api/moves/{id}
     * @secure
     */
    movesControllerUpdate: (
      id: string,
      data: UpdateMoveDto,
      params: RequestParams = {},
    ) =>
      this.request<MoveResponseDto, void>({
        path: `/api/moves/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a move (move will be marked as deleted but not physically removed)
     *
     * @tags moves
     * @name MovesControllerSoftDelete
     * @summary Delete move
     * @request DELETE:/api/moves/{id}
     * @secure
     */
    movesControllerSoftDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/moves/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new move source with automatic platform detection from URL
     *
     * @tags move-sources
     * @name MoveSourcesControllerCreate
     * @summary Create move source
     * @request POST:/api/move-sources
     * @secure
     */
    moveSourcesControllerCreate: (
      data: CreateMoveSourceDto,
      params: RequestParams = {},
    ) =>
      this.request<MoveSourceResponseDto, void>({
        path: `/api/move-sources`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all move sources with optional filtering and pagination
     *
     * @tags move-sources
     * @name MoveSourcesControllerFindAll
     * @summary Get all move sources
     * @request GET:/api/move-sources
     * @secure
     */
    moveSourcesControllerFindAll: (
      query?: {
        /**
         * Filter by move ID
         * @format uuid
         * @example "123e4567-e89b-12d3-a456-426614174001"
         */
        moveId?: string;
        /**
         * Filter by source type
         * @example "sms"
         */
        sourceType?: "manual" | "sms";
        /**
         * Filter by platform. Supported platforms: YouTube, Instagram, TikTok, Facebook, Vimeo, Reddit.
         * @example "reddit"
         */
        platform?:
          | "youtube"
          | "instagram"
          | "facebook"
          | "tiktok"
          | "vimeo"
          | "reddit";
        /**
         * Filter by original URL
         * @example "https://www.reddit.com/r/bjj/comments/abc123/pass_setup_walkthrough/"
         */
        originalUrl?: string;
        /**
         * Include related move data in response
         * @default false
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Maximum number of results to return
         * @min 1
         * @max 100
         * @default 20
         * @example 10
         */
        limit?: number;
        /**
         * Number of results to skip for pagination
         * @min 0
         * @default 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveSourceListResponseDto, any>({
        path: `/api/move-sources`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific move source by its ID
     *
     * @tags move-sources
     * @name MoveSourcesControllerFindById
     * @summary Get move source by ID
     * @request GET:/api/move-sources/{id}
     * @secure
     */
    moveSourcesControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<MoveSourceResponseDto, void>({
        path: `/api/move-sources/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing move source with automatic platform detection
     *
     * @tags move-sources
     * @name MoveSourcesControllerUpdate
     * @summary Update move source
     * @request PUT:/api/move-sources/{id}
     * @secure
     */
    moveSourcesControllerUpdate: (
      id: string,
      data: UpdateMoveSourceDto,
      params: RequestParams = {},
    ) =>
      this.request<MoveSourceResponseDto, void>({
        path: `/api/move-sources/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a move source
     *
     * @tags move-sources
     * @name MoveSourcesControllerDelete
     * @summary Delete move source
     * @request DELETE:/api/move-sources/{id}
     * @secure
     */
    moveSourcesControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/move-sources/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve the source information for a specific move (one-to-one relationship)
     *
     * @tags move-sources
     * @name MoveSourcesControllerFindByMoveId
     * @summary Get move source by move ID
     * @request GET:/api/move-sources/move/{moveId}
     * @secure
     */
    moveSourcesControllerFindByMoveId: (
      moveId: string,
      params: RequestParams = {},
    ) =>
      this.request<MoveSourceResponseDto, void>({
        path: `/api/move-sources/move/${moveId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get count of move sources by source type (MANUAL vs SMS)
     *
     * @tags move-sources
     * @name MoveSourcesControllerGetSourceTypeAnalytics
     * @summary Get source type analytics
     * @request GET:/api/move-sources/analytics/source-types
     * @secure
     */
    moveSourcesControllerGetSourceTypeAnalytics: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 25 */
          MANUAL?: number;
          /** @example 15 */
          SMS?: number;
        },
        any
      >({
        path: `/api/move-sources/analytics/source-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get count of move sources by platform
     *
     * @tags move-sources
     * @name MoveSourcesControllerGetPlatformAnalytics
     * @summary Get platform analytics
     * @request GET:/api/move-sources/analytics/platforms
     * @secure
     */
    moveSourcesControllerGetPlatformAnalytics: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example 12 */
          YOUTUBE?: number;
          /** @example 8 */
          INSTAGRAM?: number;
          /** @example 3 */
          FACEBOOK?: number;
          /** @example 5 */
          TIKTOK?: number;
          /** @example 2 */
          VIMEO?: number;
          /** @example 4 */
          REDDIT?: number;
        },
        any
      >({
        path: `/api/move-sources/analytics/platforms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerCreate
     * @summary Create a new series
     * @request POST:/api/series
     * @secure
     */
    seriesControllerCreate: (
      data: CreateSeriesDto,
      params: RequestParams = {},
    ) =>
      this.request<SeriesResponseDto, void>({
        path: `/api/series`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerFindAll
     * @summary Get all series for the authenticated user
     * @request GET:/api/series
     * @secure
     */
    seriesControllerFindAll: (
      query?: {
        /**
         * Search text to filter series by name or description
         * @example "guard passing"
         */
        searchText?: string;
        /**
         * Set to true to load each series' seriesMoves, moveConnections and taggings. Without it, none of them is sent.
         * @default false
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Restrict results to the member's favourites
         * @default false
         * @example true
         */
        favouritesOnly?: boolean;
        /**
         * Maximum number of results to return
         * @min 1
         * @max 100
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * Number of results to skip (for pagination)
         * @min 0
         * @default 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeriesListResponseDto, void>({
        path: `/api/series`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerFindOne
     * @summary Get a specific series by ID
     * @request GET:/api/series/{id}
     * @secure
     */
    seriesControllerFindOne: (
      id: string,
      query: {
        includeRelations: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeriesResponseDto, void>({
        path: `/api/series/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerUpdate
     * @summary Update a series
     * @request PUT:/api/series/{id}
     * @secure
     */
    seriesControllerUpdate: (
      id: string,
      data: UpdateSeriesDto,
      params: RequestParams = {},
    ) =>
      this.request<SeriesResponseDto, void>({
        path: `/api/series/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerRemove
     * @summary Delete a series
     * @request DELETE:/api/series/{id}
     * @secure
     */
    seriesControllerRemove: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/series/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Series
     * @name SeriesControllerUpdatePositions
     * @summary Update move node positions within a series
     * @request PATCH:/api/series/{id}/positions
     * @secure
     */
    seriesControllerUpdatePositions: (
      id: string,
      data: UpdateSeriesPositionsDto,
      params: RequestParams = {},
    ) =>
      this.request<SeriesResponseDto, void>({
        path: `/api/series/${id}/positions`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new relationship between a series and a move
     *
     * @tags series-moves
     * @name SeriesMovesControllerCreate
     * @summary Add move to series
     * @request POST:/api/series-moves
     * @secure
     */
    seriesMovesControllerCreate: (
      data: CreateSeriesMoveDto,
      params: RequestParams = {},
    ) =>
      this.request<SeriesMoveResponseDto, void>({
        path: `/api/series-moves`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all series-move relationships with optional filtering and pagination
     *
     * @tags series-moves
     * @name SeriesMovesControllerFindAll
     * @summary Get all series-move relationships
     * @request GET:/api/series-moves
     * @secure
     */
    seriesMovesControllerFindAll: (
      query?: {
        /**
         * Filter by specific series ID
         * @example "550e8400-e29b-41d4-a716-446655440000"
         */
        seriesId?: string;
        /**
         * Filter by specific move ID
         * @example "550e8400-e29b-41d4-a716-446655440000"
         */
        moveId?: string;
        /**
         * Include related data (series and move details)
         * @default false
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Maximum number of results to return (1-100)
         * @min 1
         * @max 100
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * Number of results to skip (for pagination)
         * @min 0
         * @default 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeriesMoveListResponseDto, void>({
        path: `/api/series-moves`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific series-move relationship by its ID
     *
     * @tags series-moves
     * @name SeriesMovesControllerFindById
     * @summary Get series-move relationship by ID
     * @request GET:/api/series-moves/{id}
     * @secure
     */
    seriesMovesControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<SeriesMoveResponseDto, void>({
        path: `/api/series-moves/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a series-move relationship
     *
     * @tags series-moves
     * @name SeriesMovesControllerDelete
     * @summary Remove move from series
     * @request DELETE:/api/series-moves/{id}
     * @secure
     */
    seriesMovesControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/series-moves/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve all moves that belong to a specific series
     *
     * @tags series-moves
     * @name SeriesMovesControllerGetMovesInSeries
     * @summary Get all moves in a series
     * @request GET:/api/series-moves/series/{seriesId}/moves
     * @secure
     */
    seriesMovesControllerGetMovesInSeries: (
      seriesId: string,
      params: RequestParams = {},
    ) =>
      this.request<SeriesMoveListResponseDto, void>({
        path: `/api/series-moves/series/${seriesId}/moves`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new tag for organizing moves and series
     *
     * @tags tags
     * @name TagsControllerCreate
     * @summary Create a new tag
     * @request POST:/api/tags
     * @secure
     */
    tagsControllerCreate: (data: CreateTagDto, params: RequestParams = {}) =>
      this.request<TagResponseDto, void>({
        path: `/api/tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all tags for the authenticated user with optional filtering
     *
     * @tags tags
     * @name TagsControllerFindAll
     * @summary Get all tags
     * @request GET:/api/tags
     * @secure
     */
    tagsControllerFindAll: (
      query?: {
        /**
         * User ID to filter tags by
         * @example "f47ac10b-58cc-4372-a567-0e02b2c3d479"
         */
        userId?: string;
        /**
         * Filter by exact tag name
         * @example "Guard"
         */
        name?: string;
        /**
         * Search tags by name (case-insensitive)
         * @example "guard"
         */
        searchText?: string;
        /**
         * Maximum number of tags to return (1-100)
         * @min 1
         * @max 100
         * @example 20
         */
        limit?: number;
        /**
         * Number of tags to skip for pagination
         * @min 0
         * @example 0
         */
        offset?: number;
        /**
         * Include related taggings data
         * @example false
         */
        includeRelations?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TagListResponseDto, void>({
        path: `/api/tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Search tags by name with case-insensitive matching
     *
     * @tags tags
     * @name TagsControllerSearch
     * @summary Search tags
     * @request GET:/api/tags/search
     * @secure
     */
    tagsControllerSearch: (
      query: {
        /** Search query for tag names */
        q: string;
        /**
         * Maximum number of results
         * @example 20
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TagResponseDto[], void>({
        path: `/api/tags/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get usage statistics for user tags
     *
     * @tags tags
     * @name TagsControllerGetStatistics
     * @summary Get tag statistics
     * @request GET:/api/tags/statistics
     * @secure
     */
    tagsControllerGetStatistics: (params: RequestParams = {}) =>
      this.request<
        {
          /**
           * Total number of tags for the user
           * @example 42
           */
          totalTags?: number;
        },
        void
      >({
        path: `/api/tags/statistics`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific tag by its ID
     *
     * @tags tags
     * @name TagsControllerFindById
     * @summary Get a tag by ID
     * @request GET:/api/tags/{id}
     * @secure
     */
    tagsControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<TagResponseDto, void>({
        path: `/api/tags/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing tag by ID
     *
     * @tags tags
     * @name TagsControllerUpdate
     * @summary Update a tag
     * @request PUT:/api/tags/{id}
     * @secure
     */
    tagsControllerUpdate: (
      id: string,
      data: UpdateTagDto,
      params: RequestParams = {},
    ) =>
      this.request<TagResponseDto, void>({
        path: `/api/tags/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a tag by ID (only if not currently in use)
     *
     * @tags tags
     * @name TagsControllerDelete
     * @summary Delete a tag
     * @request DELETE:/api/tags/{id}
     * @secure
     */
    tagsControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/tags/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new tagging relationship between a tag and an entity (move or series)
     *
     * @tags taggings
     * @name TaggingsControllerCreate
     * @summary Create a new tagging relationship
     * @request POST:/api/taggings
     * @secure
     */
    taggingsControllerCreate: (
      data: CreateTaggingDto,
      params: RequestParams = {},
    ) =>
      this.request<TaggingResponseDto, void>({
        path: `/api/taggings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all tagging relationships for the authenticated user with optional filtering
     *
     * @tags taggings
     * @name TaggingsControllerFindAll
     * @summary Get all taggings
     * @request GET:/api/taggings
     * @secure
     */
    taggingsControllerFindAll: (
      query?: {
        /**
         * Filter by specific tag ID
         * @example "550e8400-e29b-41d4-a716-446655440000"
         */
        tagId?: string;
        /**
         * Filter by entity type
         * @example "move"
         */
        taggableType?: "move" | "series";
        /**
         * Filter by specific entity ID
         * @example "550e8400-e29b-41d4-a716-446655440000"
         */
        taggableId?: string;
        /**
         * Include related data (tag details)
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Maximum number of results to return
         * @min 1
         * @max 100
         * @example 20
         */
        limit?: number;
        /**
         * Number of results to skip (for pagination)
         * @min 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaggingListResponseDto, any>({
        path: `/api/taggings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific tagging relationship by ID
     *
     * @tags taggings
     * @name TaggingsControllerFindById
     * @summary Get tagging by ID
     * @request GET:/api/taggings/{id}
     * @secure
     */
    taggingsControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<TaggingResponseDto, void>({
        path: `/api/taggings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing tagging relationship
     *
     * @tags taggings
     * @name TaggingsControllerUpdate
     * @summary Update tagging
     * @request PUT:/api/taggings/{id}
     * @secure
     */
    taggingsControllerUpdate: (
      id: string,
      data: UpdateTaggingDto,
      params: RequestParams = {},
    ) =>
      this.request<TaggingResponseDto, void>({
        path: `/api/taggings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a tagging relationship
     *
     * @tags taggings
     * @name TaggingsControllerDelete
     * @summary Delete tagging
     * @request DELETE:/api/taggings/{id}
     * @secure
     */
    taggingsControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/taggings/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve all tags applied to a specific entity (move or series)
     *
     * @tags taggings
     * @name TaggingsControllerGetEntityTags
     * @summary Get tags for an entity
     * @request GET:/api/taggings/entity/{entityType}/{entityId}
     * @secure
     */
    taggingsControllerGetEntityTags: (
      entityType: "move" | "series",
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<EntityTagsResponseDto, void>({
        path: `/api/taggings/entity/${entityType}/${entityId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Add multiple tags to a specific entity (move or series)
     *
     * @tags taggings
     * @name TaggingsControllerAddTagsToEntity
     * @summary Add tags to an entity
     * @request POST:/api/taggings/entity/{entityType}/{entityId}/tags
     * @secure
     */
    taggingsControllerAddTagsToEntity: (
      entityType: "move" | "series",
      entityId: string,
      data: ApplyTagsToEntityDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/taggings/entity/${entityType}/${entityId}/tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Remove a specific tag from an entity (move or series)
     *
     * @tags taggings
     * @name TaggingsControllerRemoveTagFromEntity
     * @summary Remove tag from an entity
     * @request DELETE:/api/taggings/entity/{entityType}/{entityId}/tags
     * @secure
     */
    taggingsControllerRemoveTagFromEntity: (
      entityType: "move" | "series",
      entityId: string,
      data: RemoveTagFromEntityDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/taggings/entity/${entityType}/${entityId}/tags`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a directional connection between two moves within a series
     *
     * @tags move-connections
     * @name MoveConnectionsControllerCreate
     * @summary Create a new move connection
     * @request POST:/api/move-connections
     * @secure
     */
    moveConnectionsControllerCreate: (
      data: CreateMoveConnectionDto,
      params: RequestParams = {},
    ) =>
      this.request<MoveConnectionResponseDto, void>({
        path: `/api/move-connections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all move connections with optional filtering
     *
     * @tags move-connections
     * @name MoveConnectionsControllerFindAll
     * @summary Get all move connections
     * @request GET:/api/move-connections
     * @secure
     */
    moveConnectionsControllerFindAll: (
      query?: {
        /**
         * Filter by series ID
         * @example "550e8400-e29b-41d4-a716-446655440000"
         */
        seriesId?: string;
        /**
         * Filter by from move ID
         * @example "550e8400-e29b-41d4-a716-446655440001"
         */
        fromMoveId?: string;
        /**
         * Filter by to move ID
         * @example "550e8400-e29b-41d4-a716-446655440002"
         */
        toMoveId?: string;
        /**
         * Filter by connections involving this move ID (either from or to)
         * @example "550e8400-e29b-41d4-a716-446655440003"
         */
        moveId?: string;
        /**
         * Include related data (series, fromMove, toMove)
         * @default false
         * @example true
         */
        includeRelations?: boolean;
        /**
         * Maximum number of results to return
         * @min 1
         * @max 100
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * Number of results to skip (for pagination)
         * @min 0
         * @default 0
         * @example 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveConnectionListResponseDto, any>({
        path: `/api/move-connections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all connections within a specific series
     *
     * @tags move-connections
     * @name MoveConnectionsControllerGetSeriesConnections
     * @summary Get connections for a series
     * @request GET:/api/move-connections/series/{seriesId}
     * @secure
     */
    moveConnectionsControllerGetSeriesConnections: (
      seriesId: string,
      query?: {
        /**
         * Include related move and series data
         * @default false
         * @example true
         */
        includeRelations?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveConnectionResponseDto[], any>({
        path: `/api/move-connections/series/${seriesId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all connections involving a specific move
     *
     * @tags move-connections
     * @name MoveConnectionsControllerGetMoveConnections
     * @summary Get connections for a move
     * @request GET:/api/move-connections/move/{moveId}
     * @secure
     */
    moveConnectionsControllerGetMoveConnections: (
      moveId: string,
      query?: {
        /**
         * Include related move and series data
         * @default false
         * @example true
         */
        includeRelations?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MoveConnectionResponseDto[], any>({
        path: `/api/move-connections/move/${moveId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a specific move connection by ID
     *
     * @tags move-connections
     * @name MoveConnectionsControllerFindById
     * @summary Get move connection by ID
     * @request GET:/api/move-connections/{id}
     * @secure
     */
    moveConnectionsControllerFindById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<MoveConnectionResponseDto, void>({
        path: `/api/move-connections/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a move connection
     *
     * @tags move-connections
     * @name MoveConnectionsControllerDelete
     * @summary Delete move connection
     * @request DELETE:/api/move-connections/{id}
     * @secure
     */
    moveConnectionsControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/move-connections/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Remove a connection by series, from move, and to move IDs
     *
     * @tags move-connections
     * @name MoveConnectionsControllerRemoveConnection
     * @summary Remove specific connection
     * @request DELETE:/api/move-connections/series/{seriesId}/from/{fromMoveId}/to/{toMoveId}
     * @secure
     */
    moveConnectionsControllerRemoveConnection: (
      seriesId: string,
      fromMoveId: string,
      toMoveId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/move-connections/series/${seriesId}/from/${fromMoveId}/to/${toMoveId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Idempotent. A repeat call returns the same status and the same body.
     *
     * @tags favourites
     * @name FavouritesControllerMark
     * @summary Mark a move or series as a favourite
     * @request PUT:/api/favourites/{entityType}/{entityId}
     * @secure
     */
    favouritesControllerMark: (
      entityType: "move" | "series",
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<FavouriteStateResponseDto, void>({
        path: `/api/favourites/${entityType}/${entityId}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Idempotent. Succeeds whether or not the entity was favourited.
     *
     * @tags favourites
     * @name FavouritesControllerUnmark
     * @summary Unmark a move or series as a favourite
     * @request DELETE:/api/favourites/{entityType}/{entityId}
     * @secure
     */
    favouritesControllerUnmark: (
      entityType: "move" | "series",
      entityId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/favourites/${entityType}/${entityId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Aggregated counts and recent items for the home screen. Replaces three separate list calls with a single round trip.
     *
     * @tags dashboard
     * @name DashboardControllerGetSummary
     * @summary Get dashboard summary
     * @request GET:/api/dashboard/summary
     * @secure
     */
    dashboardControllerGetSummary: (params: RequestParams = {}) =>
      this.request<DashboardSummaryResponseDto, void>({
        path: `/api/dashboard/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a name (always), a thumbnail URL (never guaranteed), a duration (best-effort, Vimeo only) and the platform derived from the URL. This is not a POST /moves body as it stands: `platform` is not a CreateMoveDto field, so ValidationPipe rejects it as a forbidden property, and CreateMoveDto requires a `description`, which this response does not carry. What the response does share with move create is length. CreateMoveDto measures `name` (1 to 255) and `thumbnailUrl` (at most 500) once each, in code points, after @TrimAndSanitize has escaped them. This route measures in UTF-16 code units, which are never fewer than code points, so a value it returns is within that maximum. `name` is shortened until its escaped form is at most 255 code units and the raw string at most 500, and a remote title that escapes to nothing (one that is only `&nbsp;`, say) is replaced by a name derived from the URL. `thumbnailUrl` is returned only when it is an https URL and both the raw string and its escaped form are at most 500 code units; one that fails is dropped rather than truncated, because cutting a URL does not yield a shorter URL that still resolves to the same image. Escaping can lengthen a value (`&` becomes `&amp;`) or shorten it (an entity such as `&#x2764;` becomes one character), which is why both lengths are checked.
     *
     * @tags video-metadata
     * @name VideoMetadataControllerLookup
     * @summary Look up metadata for a video URL
     * @request POST:/api/video-metadata
     * @secure
     */
    videoMetadataControllerLookup: (
      data: VideoMetadataLookupDto,
      params: RequestParams = {},
    ) =>
      this.request<VideoMetadataResponseDto, void>({
        path: `/api/video-metadata`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
